import service from '@/util/service';

// team
export const getComanyList = params => service.jsonGet('/api/business/workerInfo/managerRole/companyList', params);

export const getTeamList = params => service.jsonGet('/api/business/project/assign/company/list', params);

export const getAssignInfo = params => service.jsonGet('/api/business/project/assign/info', params);

export const saveTeam = params => service.jsonPost('/api/business/project/assign/company/save', params);

export const getTeam = params => service.jsonGet('/api/business/project/assign/company/view', params);

export const reassignTeam = params => service.jsonPost('/api/business/project/assign/company/delRecept', params);

export const getWorkerList = params => service.jsonGet('/api/business/project/assign/worker/list', params);

export const saveWorker = params => service.jsonPost('/api/business/project/assign/worker/save', params);

export const deleteWorker = params => service.jsonPost('/api/business/project/assign/worker/del', params);

export const clearWorker = params => service.jsonPost('/api/business/project/assign/worker/clear', params);

export const getWorker = params => service.jsonGet('/api/business/project/assign/worker/view', params);

export const undoRelease = params => service.jsonPost('/api/business/project/assign/laborMarket/delete', params);

export const releaseAssist = params => service.jsonPost('/api/business/project/assign/laborMarket/assist/addOrUpdate', params);

export const getReleaseAssist = params => service.jsonGet('/api/business/project/assign/laborMarket/assist/view', params);

export const releaseNormal = params => service.jsonPost('/api/business/project/assign/laborMarket/normal/addOrUpdate', params);

export const getReleaseNormal = params => service.jsonGet('/api/business/project/assign/laborMarket/normal/view', params);



// WEBPACK FOOTER //
// ./src/api/team/worker.js